/**
 *  @property {number} cid - careplus的套餐id
 *  @property {number} replaceCostCid - 关联置换费的套餐id（工单商品套餐）
 */
const Data = {
  X5: {
    cid: 3906,
    replaceCostCid: 3947, // 正式: 3947   test: 4029
  },
  Fmg2pro: {
    cid: 3818,
    replaceCostCid: 3819, // 正式: 3819  test: 3966
  },
  AcePro2: {
    cid: 3440,
    replaceCostCid: 3652, // 正式：3652  test: 3841
  },
  AcePro: {
    cid: 2909,
    replaceCostCid: 2924,
  },
  Ace: {
    cid: 2911,
    replaceCostCid: 2923,
  },
  X4: {
    cid: 2990,
    replaceCostCid: 3024, // 正式
    // replaceCostCid: 3013, // test
  },
  go3s: {
    cid: 3142,
    replaceCostCid: 3200, // 正式
    // replaceCostCid: 3201, // test
  },
  Link2: {
    cid: 3407,
    replaceCostCid: 3482, // 正式
    // replaceCostCid: 3517, // test
  },
  Link2C: {
    cid: 3406,
    replaceCostCid: 3483, // 正式
    // replaceCostCid: 3515, // test
  },
};

export default { Data };
